import { render, staticRenderFns } from "./SettingsIndexSourceEditor.vue?vue&type=template&id=56973662&"
import script from "./SettingsIndexSourceEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexSourceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports